import { Address, Token, feeTierToTickSpacing } from 'nftx.js';
import LiquidityChart from './LiquidityChart';
import { useState } from 'react';
import { DEFAULT_SURROUNDING_TICKS, formatTicksForChart } from './utils';
import usePoolTicks from '@/application/read/pools/usePoolTicks';

const LiquidityChartContainer = ({
  tick,
  feeTier,
  tickLower,
  tickUpper,
  poolAddress,
  liquidity,
  inputTokens,
  userLiquidity,
}: {
  tick: bigint;
  feeTier: number;
  tickLower?: bigint;
  tickUpper?: bigint;
  userLiquidity?: bigint;
  poolAddress: Address | undefined;
  liquidity: bigint;
  inputTokens: Token[];
}) => {
  // maybe do zooming in/out in the future using this to add/remove ticks to the query
  const [numSurroundingTicks, setNumSurroundingTicks] = useState(
    DEFAULT_SURROUNDING_TICKS
  );
  const poolCurrentTickIdx = Number(tick);
  const tickSpacing = feeTierToTickSpacing(feeTier);

  // The pools current tick isn't necessarily a tick that can actually be initialized.
  // Find the nearest valid tick given the tick spacing.
  const activeTickIdx =
    Math.floor(poolCurrentTickIdx / tickSpacing) * tickSpacing;

  // Our search bounds must take into account fee spacing. i.e. for fee tier 1%, only
  // ticks with index 200, 400, 600, etc can be active.
  const tickIdxLowerBound = activeTickIdx - numSurroundingTicks * tickSpacing;
  const tickIdxUpperBound = activeTickIdx + numSurroundingTicks * tickSpacing;

  const { data: ticks = [] } = usePoolTicks({
    poolAddress,
    tickSpacing,
    tickIdxLowerBound,
    tickIdxUpperBound,
  });

  const formattedData = formatTicksForChart(
    liquidity,
    activeTickIdx,
    feeTier,
    ticks,
    numSurroundingTicks,
    Number(tickUpper || 0),
    Number(tickLower || 0),
    userLiquidity
  );

  return (
    <LiquidityChart
      liquidityBase={Number(liquidity)}
      tickLower={tickLower}
      tickUpper={tickUpper}
      data={formattedData}
      activeTick={activeTickIdx}
      inputTokens={inputTokens}
    />
  );
};
export default LiquidityChartContainer;
